export interface TranscribeA1CTitleComponentProps { }

export const TranscribeA1CTitleComponent = () => (
  <span>A1C Transcribe</span>
);
